import React from "react";
import getConfig from "next/config";
import { useRouter } from "next/router";

const { publicRuntimeConfig } = getConfig();
const deprecatedRouteRegexes = publicRuntimeConfig.NEXT_PUBLIC_DEPRECATED_ROUTES?.split(",") || [];
const toBeDeprecatedRouteRegexes = publicRuntimeConfig.NEXT_PUBLIC_TO_BE_DEPRECATED_ROUTES?.split(",") || [];

export function Deprecator({ children }) {
  const router = useRouter();
  const pathname = router.pathname;
  const isDeprecated = React.useMemo(
    () => deprecatedRouteRegexes.some((regex) => pathname.match(new RegExp(regex, "i"))),
    [pathname],
  );
  const isToBeDeprecated = React.useMemo(
    () => toBeDeprecatedRouteRegexes.some((regex) => pathname.match(new RegExp(regex, "i"))),
    [pathname],
  );

  React.useEffect(() => {
    if (isToBeDeprecated && !isDeprecated) {
      alert("This page is deprecated and will be removed soon. Please use MMX");
    }
  }, [isToBeDeprecated, isDeprecated, pathname]);

  if (isDeprecated) {
    return (
      <div
        style={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <h1>This page has been lost forever</h1>
        <div>
          <iframe
            width="1120"
            height="630"
            src="https://www.youtube.com/embed/qvCVEYI7BjU?autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0&amp;start=432&amp;mute=1"
            title="Lets sing it together"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  return children;
}
